import React from "react";
import { Box, Typography, Stack } from "@mui/material";

const CompanyOverview = () => {
  const clients = [
    "株式会社フジテレビジョン",
    "株式会社NTTアド",
    "NTTドコモビジネス株式会社",
    "株式会社NTTデータ",
    "東急不動産ホールディングス株式会社",
    "株式会社エアトリ",
    "株式会社フロンティアダイレクト",
    "株式会社 Schoo/LoLLL株式会社",
    "株式会社丸善ジュンク堂書店",
    "ダイヤモンドオフィスサービス株式会社",
    "マーサージャパン株式会社",
    "佐川印刷株式会社",
    "株式会社八木クリエイティブ",
    "株式会社ANOBAKA",
  ];

  return (
    <Box
      id="company"
      sx={{
        backgroundColor: "#E60012",
        color: "white",
        padding: { xs: "50px 20px", md: "80px", xl: "90px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "hidden",
        borderTopRightRadius: {
          xs: "100px",
          sm: "110px",
          md: "260px",
          lg: "330px",
        },
        borderBottomLeftRadius: {
          xs: "100px",
          sm: "110px",
          md: "260px",
          lg: "330px",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: { xl: "1440px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "stretch",
          gap: { xs: 5, md: 4, lg: 6 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "clamp(40px, 6vw, 80px)",
              fontFamily: "Roboto, sans-serif",
              mb: 1,
              whiteSpace: "nowrap",
            }}
          >
            Company
          </Typography>
          <Typography
            sx={{
              fontSize: "clamp(16px, 4.5vw, 32px)",
              fontFamily: "Roboto, sans-serif",
              mb: 4,
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            会社概要
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              gap: { xs: 5, lg: 6 },
              alignItems: "flex-start",
            }}
          >
            <Stack
              spacing={{ xs: 3, md: 3 }}
              sx={{ flex: 1, minWidth: 0, width: "100%", pb: { xs: 5, md: 0 } }}
            >
              {[
                ["会社名", "YouProduce株式会社"],
                ["設立", "2021年2月1日"],
                ["代表", "滝田亜希子"],
              ].map(([label, value], i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    gap: { xs: 0, md: "20px" },
                    alignItems: "flex-start",
                    flexDirection: { xs: "column", md: "row" },
                    whiteSpace: "nowrap",
                    mt: { xs: 0, md: 0 },
                    mb: { xs: 0, md: 0 },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: { xs: "bold", md: "400" },
                      fontFamily: "Roboto, sans-serif",
                      width: { xs: "100%", md: "150px" },
                      fontSize: "clamp(14px, 3.5vw, 16px)",
                      flexShrink: 0,
                    }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "clamp(14px, 3.5vw, 16px)",
                      flex: 1,
                      fontWeight: "200",
                      fontFamily: "Roboto, sans-serif",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </Typography>
                </Box>
              ))}

              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 0, md: "20px" },
                  alignItems: "flex-start",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: { xs: "bold", md: "400" },
                    fontFamily: "Roboto, sans-serif",
                    width: { xs: "100%", md: "150px" },
                    fontSize: "clamp(14px, 3.5vw, 16px)",
                    flexShrink: 0,
                  }}
                >
                  所在地
                </Typography>
                <Typography
                  sx={{
                    fontSize: "clamp(14px, 3.5vw, 16px)",
                    flex: 1,
                    fontWeight: "200",
                    fontFamily: "Roboto, sans-serif",
                    whiteSpace: { xs: "pre-line", md: "nowrap" },
                  }}
                >
                  {`〒104-0045\n東京都中央区築地1丁目12-12`}
                </Typography>
              </Box>
            </Stack>
            <Box
              sx={{
                display: "flex",
                flex: 1,
                minWidth: 0,
                gap: { xs: 1, md: "20px" },
                alignItems: "flex-start",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: { xs: "bold", md: "400" },
                  fontFamily: "Roboto, sans-serif",
                  width: { xs: "100%", md: "150px" },
                  fontSize: "clamp(14px, 3.5vw, 16px)",
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                }}
              >
                主なクライアント
              </Typography>
              <Box sx={{ flex: 1 }}>
                {clients.map((client, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontSize: "clamp(14px, 3.5vw, 16px)",
                      fontWeight: "200",
                      fontFamily: "Roboto, sans-serif",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {client}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyOverview;
